import { NotificationResources } from '../constants/notification'

export const getSherpaRoutes = ({
  resourceType,
  resourceTypeId,
  meta,
}: IGetPlatformRoutes): string => {
  switch (resourceType) {
    case NotificationResources.Project:
      return `/app/sherpa/projects/${resourceTypeId}/dashboard`
    case NotificationResources.Schedule: {
      if (meta.projectId && meta.type) {
        return `/app/sherpa/projects/${meta.projectId}/${meta.type}`
      } else {
        return `/app/sherpa/projects`
      }
    }
    case NotificationResources.Task:
      return `/app/dashboard/tasks/${resourceTypeId}`
    case NotificationResources.TaskComment:
      return `/app/dashboard/tasks/${meta.tdmId}`
    case NotificationResources.Milestone:
      return `/app/dashboard/milestones/${resourceTypeId}`
    case NotificationResources.MilestoneComment:
      return `/app/dashboard/milestones/${meta.tdmId}`
    case NotificationResources.Deliverable:
      return `/app/dashboard/deliverables/${resourceTypeId}`
    case NotificationResources.DeliverableComment:
      return `/app/dashboard/deliverables/${meta.tdmId}`
    case NotificationResources.Approval: {
      if (meta.refId && meta.refType) {
        return `/app/dashboard/${meta.refType.toString().toLowerCase()}s/${
          meta.refId
        }`
      } else {
        return `/app/sherpa/projects`
      }
    }
    default:
      throw new Error('resource type not recognized for sherpa app')
  }
}
